import { c as _c } from "react/compiler-runtime";
import { CmsPageTakeover } from '@spa/top-level-components/cms-page/CmsComponentPage';
import { ReactNode } from 'react';
export interface Props {
  readonly takeover: CmsPageTakeover | null;
}
const buildPaddingExpression = (width: number, height: number): string => {
  return `calc(min(100vw, 1488px) * ${height} / ${width})`;
};
function TakeoverPageStylesComponent(t0) {
  const $ = _c(2);
  const {
    takeover
  } = t0;
  let t1;
  if ($[0] !== takeover) {
    t1 = takeover !== null && <style>{`
      body {
        background-color: ${takeover.backgroundColor};
        padding-top: ${buildPaddingExpression(takeover.topBannerMobile.width, takeover.topBannerMobile.height)};
      }

      @media (min-width: 600px) {
        body {
          padding-top: ${buildPaddingExpression(takeover.topBannerTablet.width, takeover.topBannerTablet.height)};
        }
      }

      @media (min-width: 1024px) {
        body {
          padding-top: ${buildPaddingExpression(takeover.topBannerDesktop.width, takeover.topBannerDesktop.height)};
        }
      }
    `}</style>;
    $[0] = takeover;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export default TakeoverPageStylesComponent;